// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconExclamationTriangle = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M11 9v6h2V9zm2 7h-2v2h2z" />,
    <path fillRule="evenodd" d="M11.116 2.532l-9 17L3 21h18l.884-1.468-9-17zM19.34 19H4.661L12 5.137z" />
  );
export default SvgIconExclamationTriangle;
